import { PERCENTAGE_METRICS } from '../../../types/reporting';

/**
 * Mirrors backend `calculateChanges` for a single metric.
 * - Percentage metrics: percentage-point difference
 * - Count/dollar metrics: relative % change; omitted when prior is 0
 */
export function calculateMetricChange(
    current: number | undefined,
    prior: number | undefined,
    metricOrIsPercent: string | boolean,
): number | undefined {
    if (current === undefined || prior === undefined) return undefined;

    const isPercentage = typeof metricOrIsPercent === 'boolean'
        ? metricOrIsPercent
        : (PERCENTAGE_METRICS as readonly string[]).includes(metricOrIsPercent);

    if (isPercentage) {
        return Number((current - prior).toFixed(2));
    }
    if (prior !== 0) {
        return Number((((current / prior) - 1) * 100).toFixed(2));
    }
    return undefined;
}

export function changeSuffix(isPercentage: boolean): 'pp' | '%' {
    return isPercentage ? 'pp' : '%';
}
